import './js/languageTranslate';
import './js/themeBtn'
import './js/menu';
import './js/faq';
import './js/directions';
import './js/activities';
import './js/map';
import './js/more';
import './js/topBtn';
import './js/switchLangBtn';
import './js/modal';
